import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import download from 'downloadjs';
import moment from 'moment'

export default {
	name: 'SorterConfigComponent',
	components: {
		BasicSelect,
		VueElementLoading,
		download
	},
	data: function() {
		return {
			sorterHubId:'',
			sorterHubName:'',
			createdBy:"",
			isLoadingUpload :false,
			isLoadingSearch :false,
			failed:[],
			fileDetails:[],
			addmodalShow: false,
			selectedConfig: '',
			configFileLogs: [],
			showModal: false,
			url: '',
      configFile:'',
      serr:'',
			filetypelist: [{
        value: 'fwd',
        text: 'FWD'
      },{
        value: 'rvprto',
        text: 'RVP/RTO'
      }],
			filetypeitem: {},
      filetype: '',
			currentTab: 'upload',
      tabs: [{
					key: 'upload',
					value: 'Sorter Config',
          count: 0
				},
				{
					key: 'history',
					value: 'History'
				}
			],
			archiveLimit: 50,
			selectedLayouts: [],
			viewlayoutmodel: false,
			layoutDetails: [],
			selectedLayoutDetails: [],
			selectedLayoutNumbers: [],
			activelayout: false,
			isdisableupload: false
		}
	},
	created: function() {},
	computed: {
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		},
	},
	filters: {
    moment: function(date) {
      if (date == '' || date == null) {
        return '--'
      }
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
	moment1: function(timestamp){
		const convertTimestamp = new Date(timestamp).toLocaleString('en-GB', 
		{ 
			timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric', 
			hour: '2-digit', minute: '2-digit', second: '2-digit' })
			.replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/, '$1-$2-$3 $4:$5:$6');
		return convertTimestamp;
	},
  },
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.createdBy = userdetail[0].email;
		this.sorterHubId = userdetail[0].HubId[0];

		this.getHubName(userdetail[0].HubId);
		
		this.validateConfigUpload(userdetail[0].HubId);
	},
	methods: {
		secondFunction(tab){
			if(tab.key == "history"){
				this.getConfigFile();
				this.getActiveLayouts();
			}
		},

		// HUB-7961: Centralize Config Upload Process (Hubops-Sorter Config)
		validateConfigUpload(hubid) {
			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'validateConfigUpload?currentHubId=' + hubid + '&useremail=' + this.createdBy,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					
					this.isdisableupload = result.data.isdisableupload
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}	
			}, error => {
				console.error(error)
			})
		},

		getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.sorterHubName = result.data.ResponseData[0].HubName
          }
        }, error => {
          console.error(error)
        })
    },

	getActiveLayouts() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops +'getAllActiveLayoutsForHub?currentHubId=' + this.sorterHubId + '&isActive='+ true,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
			this.activelayout = true;
          } else {
			this.activelayout = false;
          }
        }, error => {
          console.error(error)
        })
    },

	  uploadConfigFile(event){

			this.failed = [];
  		this.selectedFile = event.target[0].elements[1].files[0];

			if(this.selectedFile.size>5242880){
				this.$alertify.error("Failed! Upload Max File Size Should Not Be Greater Than 5 MB"); return false;

  		}else if ( /\.(csv)$/i.test(this.selectedFile.name) ||  /\.(zip)$/i.test(this.selectedFile.name)){	
				this.isLoadingUpload = true;

      	const fd = new FormData();
				fd.append('sorterHubId', this.sorterHubId);
				fd.append('sorterHubName', this.sorterHubName);
				fd.append('lastModifiedBy', this.createdBy);
				fd.append('fileData', this.selectedFile);
				fd.append('fileName', this.selectedFile.name);
				fd.append('fileType', this.filetype);

      	axios.post(apiUrl.api_url_hubops + 'sorterConfigFileUpload', fd,
      	{
        	headers: {
          	'Authorization': 'authkey xB84JJ89Hd25'
        	}
      	})
      	.then(result => {

        	if(result.data.ResultCode == 100){
          	this.$alertify.success(result.data.ReturnMessage);
						this.resetForm();
        	}else{
						this.$alertify.error(result.data.ReturnMessage);
					}

					if(result && result.data.failed && result.data.failed.length > 0){
						this.failed = result.data.failed;
					}

					this.isLoadingUpload= false;
      	}, error => {
        	console.error(error)
        	this.isLoadingUpload= false;
        	this.$alertify.error('Error Occured');
   		 	});
    	}else{
      	this.isLoadingUpload= false;
      	this.$alertify.error("Failed! Please Upload Only Valid Format: .csv OR .zip");
    	}
    },

	  onUploadSubmit: function(res) {
			this.$validator.validateAll().then((result) => {
				if(result){
					this.uploadConfigFile(event);
					event.target.reset();
				}
			}).catch(() => {
			  this.$alertify.error('Error Occured');
			});
	  },

		async exportFailedConfig() {
     this.isLoadingUpload = true;

		 let fileName = 'failedConfig';
	   let csvFields = {
				'NDC CODE': 'NDC CODE',
				'Mapped_NDC_Code': 'Mapped_NDC_Code',
				'Mode': 'Mode',
				'PTL_ID': 'PTL_ID',
				'Group_Detail': 'Group_Detail',
				'Shipment_Identifier': 'Shipment_Identifier',
				'Handover_Entity': 'Handover_Entity',
				'PTL_CutOff_Time': 'PTL_CutOff_Time',
				'BAY_NO': 'BAY_NO',
       			'SECTION': 'SECTION',
			 	'BAY_TYPE': 'BAY_TYPE',
			 	'CWB': 'CWB',
				'Reason': 'Reason',
       
     }

     await this.jsonToCSV(fileName, this.failed, csvFields);
     this.isLoadingUpload = false;
   	},

		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''

	  if(filename!='failedConfig') csvData += 'Config Name' + ',' + filename + '\n';
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },

		export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

	  resetForm(event){
			this.isLoadingUpload = false;
			this.isLoadingSearch = false;
			this.filetypeitem = {};
      this.filetype= '';
      this.configFile= '';
			this.failed = [];
			this.selectedLayouts = [];
			this.$validator.reset();
			this.errors.clear();
	  },

		getConfigFile(){
			this.serr = '';
			this.isLoadingSearch = true; this.fileDetails = [];
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getSorterConfigFile?sorterHubId='+this.sorterHubId+'&archiveLimit='+this.archiveLimit,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(async result => {
					if (result.data.ResultCode == 100) {
						this.fileDetails = result.data.ResponseData.map(item => {
							if (result.data.activeLayouts) {
								var newItem = Object.assign({}, item);
								newItem.layout = result.data.activeLayouts;
								return newItem;
							}
							return item;
						});
						this.$alertify.success(result.data.ReturnMessage);
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoadingSearch = false;
				}, error => {
					this.isLoadingSearch = false; console.error(error);
				})
		},

		selectFileType(item) {
			this.filetypeitem = item;
			this.filetype = item.value;
		},
		downloadConfig(file){
			

			if(file.createdby == "AUTOMATED-TRIGGER")
			{
				this.downloadConfigbySingedUrl(file);	
			}
			else{
				this.downloadConfigfromDB(file);
			}
		},
		downloadConfigfromDB(file){

			let fileData = [];
			this.isLoadingSearch = true;

			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getSorterConfigFileData?fileId='+file.id,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.isLoadingSearch = false;

						fileData = result.data.ResponseData;
						let fileName = file.filename;
						let csvFields = {
						 'ndccode': 'NDC CODE',
						 'mappedndccode': 'Mapped_NDC_Code',
						 'mode': 'Mode',
						 'ptlid': 'PTL_ID',
						 'groupdetail': 'Group_Detail',
						 'shipmentidentifier': 'Shipment_Identifier',
						 'handoverentity': 'Handover_Entity',
						 'ptlcutofftime': 'PTL_CutOff_Time',
						 'bayno': 'BAY_NO',
						 'section': 'SECTION',
						 'baytype': 'BAY_TYPE',
						 'cwbcode': 'CWB',
	    				}

						this.jsonToCSV(fileName, fileData, csvFields);
						this.$alertify.success("Success");

					} else {
						this.isLoadingSearch = false;
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					this.isLoadingSearch = false;
					 console.error(error);
				})	
		},
		downloadConfigbySingedUrl(file){
			
			let fileData = [];
			this.isLoadingSearch=true;
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'generateSorterConfigSignedUrl?fileName='+file.filename +'&fileType='+file.filetype+ '&sorterHubId='+file.sorterhubid,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.isLoadingSearch=false;
						this.url=result.data.ResponseData
            			var link = document.createElement('a');
						link.href = result.data.ResponseData;
						link.download = this.url;
						link.setAttribute('target','_blank');
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.$alertify.success(result.data.ReturnMessage);

					} else {
						this.isLoadingSearch=false;
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					this.isLoadingSearch=false;
					 console.error(error);
				})
		},
		selectFile(data){
			this.selectedConfig=data;
			if(data.isactive)
			{
				this.$alertify.error('Config is already Active');
				return;
			}
			this.addmodalShow=true;
		},
		takeAction(){
			this.addmodalShow=false;
			this.updateConfigStatus();
		},
		updateConfigStatus(){
			
			this.isLoadingSearch=true;

			let fileInput ={
				"sorterhubId" : this.selectedConfig.sorterhubid,
				"fileName" : this.selectedConfig.filename,
				"fileType" : this.selectedConfig.filetype,
				"event" : "active",
				"createdBy" : this.createdBy,
				"requestFrom" : "WEB"
			};

			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'updateSorterConfigEvent',
				data: fileInput,
				headers: {
				  'authorization': 'authkey xB84JJ89Hd25',
				}
			  })
			  .then(result => {
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage);
					this.getConfigFile();
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoadingSearch=false;
			  }, error => {
				this.isLoadingSearch=false;
				console.error(error)
			  })

		},
		closeStatusModal()
		{
			this.addmodalShow=false;
			this.selectedConfig='';
		},
		getSorterConfigLogs(data)
		{
			this.isLoadingSearch = true;

			 axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getSorterConfigAuditLog?fileName='+data.filename+'&sorterHubId='+data.sorterhubid,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25'
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.configFileLogs = result.data.ResponseData;
					this.isLoadingSearch = false;
					this.showModal=true;
				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoadingSearch = false;
			}, error => {
				this.isLoadingSearch = false; console.error(error);
			})
		},
		closeModal() {
			this.showModal = false;
			this.configFileLogs=[];
		  },
		  
		submitLayoutSelection() {
			if (this.selectedLayoutNumbers.length === 0) {
				this.$alertify.error('Please select at least one layout.');
				return;
			}
			const layoutUpdates = this.layoutDetails.map(layout => ({
				layoutNumber: layout.layoutnumber,
				isconfigactive: this.selectedLayoutNumbers.includes(layout.layoutnumber)
			}));
			this.isLoadingSearch = true;
			
			const layoutData = {
				currentHubId: this.sorterHubId,
				lastModifiedBy: this.createdBy,
				layoutUpdates
			};
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'updateLayoutConfigStatus',
				data: layoutData,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25'
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage || `Selected layouts: ${this.selectedLayoutNumbers.join(', ')}`);
					this.viewlayoutmodel = false;
					this.selectedLayoutNumbers = [];
					this.getConfigFile();
				} else {
					this.$alertify.error(result.data.ReturnMessage || 'Failed to update layout selection');
				}
				this.isLoadingSearch = false;
			}, error => {
				this.isLoadingSearch = false;
				console.error(error);
				this.$alertify.error('Error occurred while updating layout selection');
			});
		},
		cancelLayoutSelection() {
			this.viewlayoutmodel = false;
			this.selectedLayoutNumbers = [];
		},
		loadLayoutDetails() {
			this.isLoadingSearch = true;
			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getConfigurableLayouts?currentHubId=' + this.sorterHubId+ '&isActive='+ true,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25'
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.layoutDetails = result.data.ResponseData;
					this.selectedLayoutNumbers = this.layoutDetails
						.filter(layout => layout.isconfigactive)
						.map(layout => layout.layoutnumber);
				} else {
					this.$alertify.error('Failed to load layout details from API, using static data');
				}
				this.isLoadingSearch = false;
			}, error => {
				this.isLoadingSearch = false;
				console.error(error);
				this.$alertify.error('Error loading layout details from API, using static data');
			});
		},
		openLayoutModal() {
			this.selectedLayouts = [];
			this.viewlayoutmodel = true;
			this.loadLayoutDetails();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/SorterConfig/SorterConfig.js